import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Book, MessageCircle, Phone, Mail } from 'lucide-react';
export function SupportPage() {
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-5799">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-5800">
        <Link to="/" className="flex items-center gap-2" data-id="element-5801">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-5802"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-5803">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-6xl mx-auto px-6 py-12" data-id="element-5804">
        <h1 className="text-4xl font-bold mb-4" data-id="element-5805">Support Center</h1>
        <p className="text-lg text-gray-500 mb-12 font-mono" data-id="element-5806">
          Get help with your Citiplots account and transactions
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-5807">
          <Link to="/faq" className="bg-white border border-gray-300 p-8 hover:bg-gray-50" data-id="element-5808">
            <Book className="w-8 h-8 mb-4" data-id="element-5809" />
            <h3 className="font-bold text-lg mb-2" data-id="element-5810">FAQ</h3>
            <p className="text-sm text-gray-600" data-id="element-5811">
              Browse frequently asked questions
            </p>
          </Link>

          <Link to="/contact" className="bg-white border border-gray-300 p-8 hover:bg-gray-50" data-id="element-5812">
            <MessageCircle className="w-8 h-8 mb-4" data-id="element-5813" />
            <h3 className="font-bold text-lg mb-2" data-id="element-5814">Contact Us</h3>
            <p className="text-sm text-gray-600" data-id="element-5815">Send us a message</p>
          </Link>

          <a href="tel:+911234567890" className="bg-white border border-gray-300 p-8 hover:bg-gray-50" data-id="element-5816">
            <Phone className="w-8 h-8 mb-4" data-id="element-5817" />
            <h3 className="font-bold text-lg mb-2" data-id="element-5818">Call Support</h3>
            <p className="text-sm text-gray-600" data-id="element-5819">+91 123 456 7890</p>
          </a>

          <a href="mailto:support@citiplots.com" className="bg-white border border-gray-300 p-8 hover:bg-gray-50" data-id="element-5820">
            <Mail className="w-8 h-8 mb-4" data-id="element-5821" />
            <h3 className="font-bold text-lg mb-2" data-id="element-5822">Email Support</h3>
            <p className="text-sm text-gray-600" data-id="element-5823">support@citiplots.com</p>
          </a>
        </div>

        <div className="bg-white border border-gray-300 p-8" data-id="element-5824">
          <h2 className="font-bold text-xl mb-4" data-id="element-5825">Popular Help Topics</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5826">
            {['How to create a listing', 'Making an offer', 'Document verification', 'Payment methods', 'Account security', 'Transaction disputes'].map((topic, i) => <Link key={i} to="/faq" className="p-3 border border-gray-200 hover:bg-gray-50 text-sm" data-id="element-5827">
                {topic}
              </Link>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-5828" />
    </div>;
}